module.exports = __webpack_public_path__ + "img/phone.a1f1b88f.png";